import { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
//MUZUN;446217;25022025
function NewbornNutrition() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
    "success"
  );

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    //medcardService.create('data1',5);
    //medcardService.delete('data2',5);
    //medcardService.save('data3',5);
  }, []);

  const handleCreateMedcardData = async () => {
    try {
      //const response = medcardService.create('data',5);
      const response = "Medcard Eklendi";
      console.log("Create API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Create API Hatası:", error);
      showAlert("Medcard eklenirken hata oluştu!", "error");
    }
  };

  const handleSaveMedcard = async () => {
    try {
      //const response = medcardService.save('data',5);
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      //const response = medcardService.delete('data',5);
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };
  const { t } = useTranslate();
  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzNurseSaveButton onClick={handleSaveMedcard} />
        <ByzMuiAddButton onClick={handleCreateMedcardData} />
        <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
        <ByzNursePrintButton2 />
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={6} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "rgb(231, 239, 252)",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("newborn-nutrition.newborn-nutrition-form")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography>{t("datetime")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>{t("createdby")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  disabled
                  label={t("createdby")}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid
                md={6}
                xs={6}
                sx={{
                  backgroundColor: "rgb(231, 239, 252)",
                  borderBottom: "1px solid #E0E0E0",
                }}
              >
                <ByzMuiTypography isTitle>
                  {t("newborn-nutrition.growth-risk-assessment")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}></Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.approved-age-week")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  label={t("newborn-nutrition.approved-age-week")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.weight")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  label={t("newborn-nutrition.weight")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.height")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  label={t("newborn-nutrition.height")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.head-circumference")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  label={t("newborn-nutrition.head-circumference")}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid
                md={6}
                xs={6}
                sx={{
                  backgroundColor: "rgb(231, 239, 252)",
                  borderBottom: "1px solid #E0E0E0",
                }}
              >
                <ByzMuiTypography isTitle>
                  {t("newborn-nutrition.risk-identification")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}></Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "rgb(231, 239, 252)",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("newborn-nutrition.high-risk")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}></Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.anyone")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.week")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.gr(birth)")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.feeding-after-nec")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ textAlign: "left" }}>
                  {t("newborn-nutrition.severe-gis-anomaly-infant")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "rgb(231, 239, 252)",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("newborn-nutrition.medium-risk")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}></Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.anyone")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.generally-well-baby-week")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ textAlign: "left" }}>
                  {t("newborn-nutrition.igur-low")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.gr(birth)2")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.nutrition-by-disease-or-anomaly")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "rgb(231, 239, 252)",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("newborn-nutrition.low-risk")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}></Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.anyone")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.generally-well-baby-week2")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ textAlign: "left" }}>
                  {t("newborn-nutrition.igur-high")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.well-appearing-term-infant")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{
                    display: "flex",
                    textAlign: "center",
                  }}
                  fontWeight={500}
                  fontSize={"14px"}
                >
                  {t("score")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  disabled
                  label={t("score")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "rgb(231, 239, 252)",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("newborn-nutrition.evaluation-for-needs")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}></Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.high-risk-above-criteria")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ textAlign: "left" }}>
                  {t("newborn-nutrition.birth-weight-not-regained-by-week")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  {t("newborn-nutrition.weight-loss-above-15pct-anytime")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ textAlign: "left" }}>
                  {t("newborn-nutrition.weight-gain-under-10gkgday-postweek")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ textAlign: "left" }}>
                  {t("newborn-nutrition.surgical-intervention-nec-or-gis")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiCheckBox sx={{ ml: 1 }} />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{
                    display: "flex",
                    textAlign: "center",
                  }}
                  fontWeight={500}
                  fontSize={"14px"}
                >
                  {t("note")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField sx={{ width: "300px" }} label={t("note")} />
              </Grid>
            </Grid>
            <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={
                alertSeverity === "success"
                  ? t("operation-successful")
                  : t("error")
              }
              message={alertMessage}
              type={alertSeverity}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default NewbornNutrition;
